import {
  SET_AVAILABLE_LOGIN_METHODS,
  SET_UPGRADE_TO_LOGIN_ELEVATED_ERROR,
  SET_UPGRADE_TO_LOGIN_ELEVATED_IN_PROGRESS,
} from '../actions/loginElevated';

export const initialState = {
  inProgress: false,
  errorCode: null,
  isCaptchaRequired: false,
  hasPassword: true,
  hasFacebook: false,
  hasPayPal: false,
  provider: null,
};

export default function loginElevated(state = initialState, action) {
  switch (action.type) {
    case SET_UPGRADE_TO_LOGIN_ELEVATED_ERROR:
      return {
        ...state,
        errorCode: action.code,
        provider: action.provider,
        isCaptchaRequired: action.isCaptchaRequired,
        inProgress: false,
      };
    case SET_UPGRADE_TO_LOGIN_ELEVATED_IN_PROGRESS:
      return {
        ...state,
        inProgress: true,
      };
    case SET_AVAILABLE_LOGIN_METHODS:
      return {
        ...state,
        hasPassword: action.hasPassword,
        hasFacebook: action.hasFacebook,
        hasPayPal: action.hasPayPal,
        errorCode: null,
        inProgress: false,
        isCaptchaRequired: false,
        provider: null,
      };
    default:
      return state;
  }
}
